import { ArrowSquareOut, CopySimple, LinkSimple } from "@/components/ui/icons";
import { routeChatLink } from "@/lib/link-routing";
import { emitTerminalTelemetry } from "@/lib/terminal-telemetry";
import { copyToClipboard } from "@/lib/clipboard";

interface CardActionsProps {
  url?: string | null;
  title?: string | null;
  summary?: string | null;
  compact?: boolean;
}

export function CardActions({
  url,
  title,
  summary,
  compact,
}: CardActionsProps) {
  const canCopySummary = !!(title || summary);
  const canCopyLink = !!url;
  const openLabel = "Open external";

  return (
    <div className="flex items-center gap-1">
      {canCopySummary && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            emitTerminalTelemetry("agent_card_action_clicked", {
              action: "copy_summary",
              has_title: Boolean(title),
            });
            void copyToClipboard(
              [title ?? "", summary ?? ""].filter(Boolean).join("\n"),
            );
          }}
          className={`inline-flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded border border-border text-muted-foreground bg-background hover:text-foreground hover:border-border transition-colors ${
            compact ? "" : "font-terminal"
          }`}
          title="Copy summary"
          aria-label="Copy summary"
        >
          <CopySimple size={10} />
          <span>Copy</span>
        </button>
      )}
      {canCopyLink && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            emitTerminalTelemetry("agent_card_action_clicked", {
              action: "copy_link",
            });
            void copyToClipboard(url ?? "");
          }}
          className={`inline-flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded border border-border text-muted-foreground bg-background hover:text-foreground hover:border-border transition-colors ${
            compact ? "" : "font-terminal"
          }`}
          title="Copy link"
          aria-label="Copy link"
        >
          <LinkSimple size={10} />
          <span>Copy link</span>
        </button>
      )}
      {url && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            const routingResult = routeChatLink(url);
            emitTerminalTelemetry("agent_card_action_clicked", {
              action: "open_link",
              route: routingResult,
            });
          }}
          className={`inline-flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded border border-info-muted text-info bg-background hover:text-foreground hover:border-info transition-colors ${
            compact ? "" : "font-terminal"
          }`}
          title={openLabel}
          aria-label={openLabel}
        >
          <ArrowSquareOut size={10} />
          <span>{openLabel}</span>
        </button>
      )}
    </div>
  );
}
